<template>
  <div
    v-show="openNamespace"
    id="floating_hints_content"
    class="flhints_cont anim-fade-in"
  >
    <div
      class="mdi mdi-close text-semi-large pa-1 icon_btn position-absolute"
      style="top: 1rem; right: -2rem"
    ></div>

    <TrainerHintsExpand
      v-click-outside="e => toggle(e)"
      style="width: 21.5rem; --max-height: var(--vh-5)"
      :canClose="false"
      :closed="false"
      :hintsProps="hintsProps"
      :storeKey="''"
    >
    </TrainerHintsExpand>
  </div>
</template>

<script>
import TrainerHintsExpand from '@/components/Trainer/TrainerHintsExpand'
import float_mix from '@/mixins/float_mix'
import { nextTick } from 'vue'

export default {
  name: 'TrainerHintsFloat',
  components: {
    TrainerHintsExpand,
  },
  mixins: [float_mix],
  props: {
    activeNamespace: { String, required: true },
    hintsProps: Object,
  },
  data() {
    return {
      openNamespace: '',
    }
  },
  methods: {
    toggle(e) {
      let nn = ''
      const { id } = e.target
      if (id.includes('floating_hints_content')) {
        nn = this.activeNamespace
      } else if (id === `${this.openNamespace}_floating_hints_opener`) {
        nn = ''
      } else if (id.includes('floating_hints_opener')) {
        nn = this.activeNamespace
      } else {
        nn = ''
      }
      this.openNamespace = nn
      if (nn) {
        this.repositionMenu()
      }
    },
    repositionMenuDelayed() {
      nextTick(() => {
        this.repositionMenu()
      })
    },
    repositionMenu() {
      const nn = this.activeNamespace
      this.$store.commit('hints_set', { key: 'hints_float_namespace', value: nn })

      const referenceEl = document.getElementById(`${nn}_floating_hints_opener`)
      const element = document.getElementById('floating_hints_content')
      this.fl_setPositionStyle({ referenceEl, element, options: { placement: 'right-start' } })
    },
  },
  watch: {
    hintsProps() {
      // console.log('TrainerHintsFloat--watcher')
      if (this.openNamespace) {
        // console.log('TrainerHintsFloat--watcher-action')
        this.repositionMenuDelayed()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.flhints_cont {
  max-height: var(--vh-3);
  position: fixed;
  z-index: 10;
  padding: 1rem 0;
}
</style>
